import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

const dashboardService = {
  /**
   * Get executive dashboard summary data
   * @param {number|string} month - Optional month filter
   * @param {number|string} year - Optional year filter
   * @returns {Promise<Object>} Dashboard data including KPIs, trends, etc.
   */
  async getSummary(month, year) {
    try {
      const params = {};
      if (month) params.month = month;
      if (year) params.year = year;
      
      const response = await apiClient.get("/dashboard/summary", { params });
      return response?.data?.data || response?.data || {};
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default dashboardService;
